import { Flex, Icon, InputText } from "@goodfill/ui-components";
import { PricedBond } from "../../../PricedBond";
import { BondFilter, BondFilterChipData, BondFilterData, BondFilterProps } from "../BondFilter";
import { BondFilterCriteria } from "../BondFilterCriteria";
import { BondFilterDataConstraints } from "../BondFilterDataConstraints";
import "./styles/BondFilterSearch.scss";

const normalizeString = (value: string) => value.trim().toLowerCase();

export class BondFilterSearch implements BondFilter {
  isVisibleInDropdown(): boolean {
    return false;
  }

  evaluate({ pricedBond }: BondFilterData, { searchString }: BondFilterCriteria): boolean {
    const search = normalizeString(searchString);
    if (!search) {
      return true;
    }
    return (
      normalizeString(pricedBond.isin).includes(search) ||
      normalizeString(pricedBond.issuerName).includes(search) ||
      normalizeString(pricedBond.issuerTicker).includes(search) ||
      normalizeString(pricedBond.paymentRank).includes(search) ||
      normalizeString(`${pricedBond.bondIdCusip}`).includes(search) ||
      normalizeString(pricedBond.industry).includes(search)
    );
  }

  updateConstraintByPricedBond(
    _pricedBond: PricedBond,
    current: BondFilterDataConstraints,
  ): BondFilterDataConstraints {
    return current;
  }

  getDefaultCriteriaConstraints(_pricedBond: PricedBond): Partial<BondFilterDataConstraints> {
    return {};
  }

  afterCriteriaCalculation(current: BondFilterDataConstraints): BondFilterDataConstraints {
    return current;
  }

  reset(criteria: BondFilterCriteria, defaultCriteria: BondFilterCriteria): BondFilterCriteria {
    return { ...criteria, searchString: defaultCriteria.searchString };
  }

  getChips(criteria: BondFilterCriteria, defaultCriteria: BondFilterCriteria): BondFilterChipData[] {
    return criteria.searchString.trim() !== ""
      ? [
          {
            id: "searchString",
            label: "Search",
            onClick: () => this.reset(criteria, defaultCriteria),
          },
        ]
      : [];
  }

  component(props: BondFilterProps) {
    const search = normalizeString(props.criteria.searchString);

    return (
      <Flex direction="row" items="center" gap={1} grow={1} className="relative">
        <InputText
          className="w-100"
          placeholder="search"
          border="neutral"
          value={props.criteria.searchString}
          setValue={(value) => {
            props.onChange({
              criteria: { ...props.criteria, searchString: value },
            });
          }}
        />
        {search && (
          <div
            className="absolute right-3"
            onClick={() => {
              props.onChange({
                criteria: { ...props.criteria, searchString: "" },
              });
            }}
          >
            <Icon name="x" />
          </div>
        )}
      </Flex>
    );
  }

  applyCriteriaFromStorage(criteria: Partial<BondFilterCriteria>): Partial<BondFilterCriteria> {
    return criteria;
  }

  storeCriteriaToStorage(_criteria: BondFilterCriteria, _defaultCriteria: BondFilterCriteria): void {
    // Intentionally not stored
  }
}
